(() => {
  'use strict';
  if (window.sidizMobilePreorder) return;
  window.sidizMobilePreorder = true;

  const viewport = window.matchMedia('(max-width: 1023px)');
  const states = new Map();
  const active = () => viewport.matches && document.body.dataset.sidizMobileCommerce === 'true';

  const move = (state, node, target, before = null) => {
    if (!node || !target) return;
    const marker = document.createComment('sidiz mobile preorder position');
    node.before(marker);
    state.moves.push({ node, marker });
    target.insertBefore(node, before);
  };

  const enhance = (landing, state) => {
    if (state.enhanced) return;
    state.enhanced = true;
    landing.querySelectorAll('[data-mobile-preorder-all]').forEach((link) => { link.hidden = false; });

    landing.querySelectorAll('.sidiz-preorder-category-story').forEach((story) => {
      const copy = story.querySelector('.sidiz-preorder-category-story__copy');
      const media = story.querySelector('.sidiz-preorder-category-story__media');
      const product = story.querySelector('.sidiz-preorder-category-story__product-summary');
      const cta = story.querySelector('.sidiz-preorder-category-story__cta');
      if (!copy || !media || !product || !cta) return;

      const firstCopy = copy.querySelector('.sidiz-preorder-category-story__eyebrow');
      const details = document.createElement('details');
      details.className = 'sidiz-mobile-preorder-details';
      const summary = document.createElement('summary');
      summary.textContent = landing.dataset.mobileStoryLabel || 'Why this chair fits';
      details.append(summary);
      state.details.push(details);

      // Move the original nodes so product links and reading order stay aligned.
      move(state, media, copy, firstCopy);
      move(state, product, copy, firstCopy);
      move(state, cta, copy, firstCopy);
      copy.insertBefore(details, firstCopy);
      [
        firstCopy,
        copy.querySelector(':scope > h3'),
        copy.querySelector('.sidiz-preorder-category-story__body'),
        copy.querySelector('.sidiz-preorder-category-story__points'),
        copy.querySelector('.sidiz-preorder-companion'),
      ].forEach((node) => move(state, node, details));
      story.dataset.mobilePreorderReady = 'true';
    });

    landing.querySelectorAll('.sidiz-preorder-products .sidiz-collection-card').forEach((card) => {
      const badge = card.querySelector('.sidiz-preorder-card-badge');
      const copy = card.querySelector('.sidiz-collection-card__copy');
      if (badge && copy) move(state, badge, copy, copy.firstChild);
    });
  };

  const restore = (landing, state) => {
    if (!state.enhanced) return;
    state.moves.forEach(({ node, marker }) => {
      if (marker.parentNode) marker.replaceWith(node);
    });
    state.details.forEach((details) => details.remove());
    landing.querySelectorAll('[data-mobile-preorder-all]').forEach((link) => { link.hidden = true; });
    landing.querySelectorAll('[data-mobile-preorder-ready]').forEach((story) => { delete story.dataset.mobilePreorderReady; });
    state.moves = [];
    state.details = [];
    state.enhanced = false;
  };

  const update = () => {
    states.forEach((state, landing) => {
      if (!landing.isConnected) {
        restore(landing, state);
        states.delete(landing);
      }
    });
    document.querySelectorAll('[data-mobile-preorder]').forEach((landing) => {
      if (!states.has(landing)) states.set(landing, { moves: [], details: [], enhanced: false });
      const state = states.get(landing);
      if (active()) enhance(landing, state);
      else restore(landing, state);
    });
  };

  const init = () => {
    update();
    viewport.addEventListener('change', update);
    new MutationObserver(update).observe(document.body, { attributes: true, attributeFilter: ['data-sidiz-mobile-commerce'] });
    document.addEventListener('shopify:section:load', update);
    document.addEventListener('shopify:section:unload', update);
    document.addEventListener('shopify:block:select', (event) => {
      if (!active() || !(event.target instanceof Element)) return;
      const story = event.target.closest('[data-mobile-preorder-ready]');
      const details = story?.querySelector('.sidiz-mobile-preorder-details');
      if (details) details.open = true;
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
